import { theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles(() =>
  createStyles({
    success: {
      paddingLeft: theme.spacing(3.3),
      marginBottom: theme.spacing(4),
    },
  })
);
